import { SearchResultsPage } from "./SearchResultsPage";

import type { FeatureModule } from "@/types/feature";

/**
 * Site search results. No nav item — reached via the header search box (or
 * the "/" shortcut), never the sidebar.
 */
export const searchFeature: FeatureModule = {
  id: "search",
  navItems: [],
  routes: [{ path: "search", element: <SearchResultsPage /> }],
};
